import { render, staticRenderFns } from "./ImageInLine.vue?vue&type=template&id=55df95f7&scoped=true&"
import script from "./ImageInLine.vue?vue&type=script&lang=js&"
export * from "./ImageInLine.vue?vue&type=script&lang=js&"
import style0 from "./ImageInLine.vue?vue&type=style&index=0&id=55df95f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df95f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDialog,VIcon,VImg,VRow})
